import React from 'react';
import { classifyAvailability } from '../utils';

const TONE = {
  high: 'bg-green-100 text-green-700',
  mid: 'bg-blue-100 text-blue-700',
  low: 'bg-amber-100 text-amber-700',
  out: 'bg-red-100 text-red-600',
  order: 'bg-slate-100 text-slate-600',
  unknown: 'bg-gray-100 text-gray-500',
};

const AvailabilityBadge = ({ value }) => {
  const { label, tone } = classifyAvailability(value);
  return (
    <span className={`inline-flex items-center rounded-md px-2.5 py-1 text-sm font-medium ${TONE[tone] || TONE.unknown}`}>
      {label}
    </span>
  );
};

export default AvailabilityBadge;
